import { Accordion } from "src/lib"
import { IRootProps } from "./types"

const Root = (props: IRootProps) => {
    return (
        <Accordion.Root sx={props.sx}>
            {props.children}
        </Accordion.Root>
    )
}

export { Root }
